export const isEmptyObject = (obj: unknown): boolean =>
  typeof obj === 'object' && obj !== null && !Array.isArray(obj) && Object.keys(obj).length === 0;
